// extracted by mini-css-extract-plugin
export default {"stack":"TechStack_stack__HX0xm","icons":"TechStack_icons__6rJAc","icon":"TechStack_icon__iXu2O"};